import { FIXED_INDENTS, INDENTS } from 'vars/index'

/* TODO: rename enums and constants like ButtonGroup* */
export const ColumnGap = {
  INDENT_20: INDENTS.INDENT_20,
  INDENT_30: INDENTS.INDENT_30,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type ColumnGap = (typeof ColumnGap)[keyof typeof ColumnGap]

export const Padding = {
  INDENT_0: INDENTS.INDENT_0,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_80: INDENTS.INDENT_80,
} as const
export type Padding = (typeof Padding)[keyof typeof Padding]

export const Direction = {
  Row: 'row',
  Column: 'column',
} as const
export type Direction = (typeof Direction)[keyof typeof Direction]

export const JustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type JustifyContent =
  (typeof JustifyContent)[keyof typeof JustifyContent]

export const Fluid = {
  Horizontal: 'horizontal',
  Vertical: 'vertical',
  Both: 'both',
  None: 'none',
} as const
export type Fluid = (typeof Fluid)[keyof typeof Fluid]

export const ButtonGroupMargins = {
  SIZE_20: [FIXED_INDENTS.INDENT_20, FIXED_INDENTS.INDENT_0],
  SIZE_90: [FIXED_INDENTS.INDENT_90, FIXED_INDENTS.INDENT_0],
  SIZE_100: [FIXED_INDENTS.INDENT_100, FIXED_INDENTS.INDENT_0],
}
export type ButtonGroupMargin =
  (typeof ButtonGroupMargins)[keyof typeof ButtonGroupMargins]
